import styled from 'styled-components';
import { Modal as SemanticModal } from 'semantic-ui-react';

import { Button as ButtonLayoutComponent, Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

export const Modal = styled(SemanticModal)``;

export const Title = styled(TextLayoutComponent)`
  font-weight: 500;
  font-size: 16px;
`;

export const Text = styled(TextLayoutComponent)`
  font-size: 14px;
  word-break: break-all;
`;

export const ContainerText = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Container = styled.div`
  padding: 10px;
`;

export const Button = styled(ButtonLayoutComponent)`
  &.ui.button {
    width: 172px;
  }
`;

export const ContainerBottom = styled.div`
  display: flex;
  padding: 0 20px;
  flex-direction: row;
  justify-content: space-between;
`;

export const ContainerTagHighlight = styled.div`
  display: flex;
  padding: 0 20px 20px;
`;

export const ContainerButton = styled.div`
  padding: 10px;
`;

export const EditLink = styled.a``;

export const ContainerMessage = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`;

export const ErrorMessage = styled(TextLayoutComponent.Error)`
  font-size: 16px;
`;
